const SocketPathPrefix = '/socket';
const Socket = {
    SOCKET_PATH_PREFIX: SocketPathPrefix,
    SOCKET_SUBSCRIBE: `${SocketPathPrefix}/subscribe`,
    SOCKET_UNSUBSCRIBE: `${SocketPathPrefix}/unsubscribe`,

    SOCKET_SLATE_LIVE_UPDATES: '/slate',

    SOCKET_ON_SET_SLATE: 'socket-on-set-slate',
    SOCKET_ON_SET_GAMES: 'socket-on-set-games',
    SOCKET_ON_SET_PLAYERS: 'socket-on-set-players',
    SOCKET_ON_UPDATE_PLAYERS: 'socket-on-update-players',
    SOCKET_ON_DELETE_PLAYERS: 'socket-on-delete-players',

    SOCKET_SET_IS_SUBSCRIBED: 'SOCKET_SET_IS_SUBSCRIBED',
};

export default Socket;
